import React, { useCallback } from 'react'
import loadComponent from 'src/utils/loadMFE'
import { Container } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const StatisticSearch = React.lazy(() => loadComponent('statistic', 'StatisticSearch'))

export function StatisticIndex() {
    const navigate = useNavigate()

    const onSelect = useCallback(
        (type: string, id: string) => {
            navigate(`/statistic/${type}/${id}`)
        },
        [navigate],
    )

    return (
        <Container>
            <StatisticSearch onSelect={onSelect} />
        </Container>
    )
}
